export default __webpack_public_path__ + "static/media/chatExampleImg.1af7ea20.png";